;(function () {

"use strict";

var AutocompleteTemplate = require('./templates/autocomplete.html');
var ResultsListingTemplate = require('./templates/autocomplete-results-listing.html');

var TokenView = Backbone.View.extend({
  tagName: 'span',
  className: 'token',
  initialize: function (opts) {
    opts = opts || {};
    this.parent = opts.parent;
    this.text = opts.text;
    this.idx = opts.idx;
    this.render();
  },
  render: function () {
    this.$el.html(this.text+'<span class="remove"></span>');
    this.$el.insertBefore(this.parent.$el.find('textarea'));
  },
  destroy: function () {
    this.$el.remove();
    this.undelegateEvents();
  },
  events: {
    'click .remove': function () {
      this.parent.remove(this.idx);
      this.destroy();
    }
  }
});

var ResultsListingView = Backbone.View.extend({
  className: 'results-listing',
  initialize: function (opts) {
    this.parent = opts.parent;
    this.$anchor = opts.$anchor;
    this.name = this.$anchor.attr('name');
    this.$el.appendTo(this.$anchor);
  },
  render: function (d) {
    this.$el.empty();

    if (!d) { return; }

    /* Change autocomplete endpoint to just return an array */
    var html = _.template(ResultsListingTemplate, {variable: 'data'})(d.data);
    this.$el.html(html);
    this.$items = this.$el.find('li');
    this.max = this.$items.length - 1;
    this.idx = -1;
    this.active = false;

    return this;
  },
  show: function () {
    this.$el.show();
  },
  hide: function () {
    this.$el.hide();
  },
  next: function () {
    if (this.idx === this.max) { return; }

    this.active = true;
    this.$el.find('ul').addClass('active');

    $(this.$items[this.idx]).removeClass('active');

    this.idx = this.idx + 1;
    $(this.$items[this.idx]).addClass('active');
  },
  prev: function () {
    if (this.idx <= 0) { 
      $(this.$items[this.idx]).removeClass('active');
      this.idx = -1;
      this.active = false;
      this.$el.find('ul').removeClass('active');
      return;
    }
    $(this.$items[this.idx]).removeClass('active');

    this.idx = this.idx -1;
    $(this.$items[this.idx]).addClass('active');
  },
  val: function () {
    return this.$items.filter('.active').attr('value');
  },
  events: {
    'click li': function (e) {
      var $this = $(e.currentTarget);
      this.$items.removeClass('active');

      this.active = true;
      this.$el.find('ul').addClass('active');
      $this.addClass('active');
      this.idx = $this.index();
      this.parent.tokenize();
      console.log('TOKENIZING');
    }
  }
});

var isLetter = function (str) {
  return str.length === 1 && str.match(/[a-z]/i);
};

var AutocompleteView = Backbone.View.extend({
  className: 'autocomplete',
  initialize: function (opts) {
    opts = opts || {};
    this.$anchor = opts.$anchor;
    this.url = opts.url;
    this.guid = window.App.guid();
    this.tokens = [];
    this.placeholder = opts.placeholder || '';
    this.max = opts.max;
    this.onResize = opts.onResize;

    this.render();
    this.readInitialValues();
    this.hideAnchor();

    $(window).on('resize.' + this.guid, _.bind(this.resize, this));
    _.defer(_.bind(this.resize, this));
  },
  hideAnchor: function () {
    this.$anchor.parent().css({'position': 'relative'});
    var p = this.$anchor.position();

    /* lazy fix */
    if (!p) { return; }

    this.$anchor.css({
      'position': 'absolute',
      'height': 0,
      'opacity': 0,
      'z-index': -1,
      'margin': 0,
      'padding': 0,
      'border': 0,
      'top': p.top,
      'left': p.left
    });
  },
  readInitialValues: function () {
    var $anchor = this.$anchor;
    var tag = $anchor.prop('tagName');
    var self = this;

    if (tag === 'SELECT') {
      this.$anchor.find('option').each(function () {
        if ($(this).attr('selected')) {
          var tv = new TokenView({parent: self, text: $(this).val(), idx: self.tokens.length });
          self.tokens.push(tv);
        }
      });
    } else {
      var val = this.$anchor.val();
      if (val) {
        _.each(val.split(','), function (t) {
          var tv = new TokenView({parent: self, text: t, idx: self.tokens.length });
          self.tokens.push(tv);
        });
      }
    }

    this.setPlaceholder();
  },
  render: function () {
    this.$el.html(_.template(AutocompleteTemplate)({placeholder: this.placeholder}));
    this.$el.insertAfter(this.$anchor);
    this.cache();
    return this;
  },
  cache: function () {
    this.$input = this.$el.find('textarea');
    this.buffer = '';
  },
  down: function () {
    if (this.rlv) {
      this.rlv.next();
    }
  },
  up: function () {
    if (this.rlv) {
      this.rlv.prev();
    }    
  },
  tokenize: function () {
    if (!this.buffer && !this.rlv.active) { return; }

    if (this.rlv && this.rlv.active) {
      this.buffer = this.rlv.val();
      this.syncBuffer();
    }

    this.clearBuffer();
    var tv = new TokenView({parent: this, text: this.buffer, idx: this.tokens.length });
    this.tokens.push(tv);
    this.setPlaceholder();
    this.buffer = '';

    if (this.rlv) {
      this.rlv.render();
    }

    this.resize();
    this.setAnchorValue();
  },
  setAnchorValue: function () {
    var $anchor = this.$anchor;
    var tag = $anchor.prop('tagName');
    if (tag === 'SELECT') {
      $anchor.empty();
      var $option;
      _.map(this.tokens, function (t) {
        $option = $("<option selected>");
        $option.val(t.text).html(t.text);
        $anchor.append($option);
      });
    } else {
      var str = '';
      _.map(this.tokens, function (t) { str += t.text + ','; });
      this.$anchor.val(str.slice(0, -1));
    }
  },
  val: function () {
    var val = [];
    _.map(this.tokens, function (t) { val.push(t.text); });
    return val;
  },
  resize: function () {
    this.$input.width('');

    var $tokens = this.$el.find('.token');
    var inlineTokens = [];
    var t = this.$input.position().top;
    var w = 0;

    $tokens.each(function () {
      if ($(this).position().top - t >= -5) {
        inlineTokens.push(this);
      }
    });

    _.each(inlineTokens, function (el, idx) {
      w += $(el).outerWidth(true);
    });

    w = this.$el.width() - w - 2;

    var val = this.$input.val();
    if ((val.length * 12) > w) {
      w = this.$el.width();
    }

    console.log(val.length * 12);
    console.log(w);

    this.$input.outerWidth(w);

    if (this.onResize) { this.onResize(); }
  },
  clearBuffer: function () {
    this.$input.val('');
  },
  setPlaceholder: function () {
    if (this.tokens.length > 0) {
      this.$el.find('textarea').attr('placeholder', '');
    } else {
      this.$el.find('textarea').attr('placeholder', this.placeholder);
    }

    console.log(this.max);
    console.log(this.tokens.length);

    if (this.max && (this.tokens.length === this.max)) {
      this.$el.find('textarea').hide();
    } else {
      this.$el.find('textarea').show();      
    }
  },
  backspace: function () {
    if (typeof this.buffer !== "string") { return; }

    if (this.buffer.length === 0 && this.tokens.length) {
      var tv = this.tokens.pop();
      this.buffer = tv.text;
      tv.destroy();
      this.syncBuffer();
      this.setAnchorValue();
      this.fetch();
      this.setPlaceholder();
      return;
    }

    this.buffer = this.buffer.slice(0,-1);
    this.syncBuffer();
    this.fetch();
  },
  syncBuffer: function () {
    this.$input.val(this.buffer);
  },
  addCharacter: function (e) {
    // var code = e.keyCode, c;

    // if (this.shiftKey) {
    //   c = String.fromCharCode(code);
    // } else {
    //   c = String.fromCharCode(code).toLowerCase();      
    // }

    // this.buffer = ('' + this.buffer) + c;
    this.buffer = this.$input.val();
    this.syncBuffer();
    this.fetch();
  },
  fetch: function () {
    if (this.url) {
      if (this.req) {
        this.req.abort();
      }
      var query = this.buffer.replace(/[^\w\s]/gi, '');
      this.req = $.get(this.url, {q: query}, _.bind(this.listResults, this));
    }    
  },
  listResults: function (d) {
    if (this.rlv) {
      this.rlv.render(d).show();
    } else {
      this.rlv = new ResultsListingView({$anchor: this.$el, parent: this}).render(d);
    }
  },
  blur: function () {
    if (this.rlv) { _.delay(_.bind(this.rlv.hide, this.rlv), 5); }
  },
  focus: function () {
    if (this.rlv) { this.rlv.show(); }
  },
  remove: function (idx) {
    this.tokens[idx].destroy();
    this.tokens.splice(idx, 1);
    this.reindex();
    this.setAnchorValue();
    this.setPlaceholder();
  },
  reindex: function () {
    _.each(this.tokens, function (view, idx) {
      view.idx = idx;
    });
  },
  disableTimeout: function () {
    clearInterval(this.timeout);
    this.timeout = undefined;

    /* Sync if editing was done */
    this.buffer = this.$input.val();
    this.syncBuffer();
    this.fetch();
  },
  setTimeout: function (shift) {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }

    var interval = shift ? 1000000000 : 500;
    this.timeout = setTimeout(_.bind(this.disableTimeout, this), interval);
  },
  destroy: function () {
    this.undelegateEvents();
    this.$el.remove();
    $(window).off('resize.' + this.guid, _.bind(this.resize, this));
  },
  events: {
    'keyup textarea': function (e) {
      var code = e.keyCode;

      if (this.timeout) { 
        return; 
      }

      this.resize();

      if (code === 40) { this.down(); return false; }
      if (code === 8) { this.backspace(); return false; }
      if (code === 13) { this.tokenize(); return false; }
      if (code === 38) { this.up(); return false; }

      _.defer(_.bind(this.addCharacter, this));

      // return false;
    },
    'keydown textarea': function (e) { 
      var code = e.keyCode;

      if (e.shiftKey) {
        this.shiftKey = true;
      } else {
        this.shiftKey = false;
      }

      if (code === 91 || code === 17 || code == 18) { 
        this.setTimeout(); return; 
      }

      // if (code === 16) {
      //   this.setTimeout(true); return;
      // }

      if (this.timeout) { return; }      

      if (code === 13) { return false; }
      // return false;
    },
    'blur textarea': 'blur',
    'focus textarea': 'focus' 
  }
});

module.exports = AutocompleteView;

}());